<template>
  <div>
    <MainPage :withArticles="false" :withEvents="false" v-if="loaded">
      <div class="page-wrapper text-center">
        <div class="home-date">September 3rd at 7:00PM ET</div>
        <div class="home-title">Experience the TOUR Championship Golf Ball</div>
        <div class="home-description">
          Mark your calendars for the TOUR Championship Golf Ball, a virtual
          kickoff to the 2020 TOUR Championship that lets you experience East
          Lake like never before while supporting TOUR Championship Charities.
        </div>

        <v-btn
          class="share-btn"
          to="/new-story"
          large
          elevation="0"
          color="primary"
          outlined
          >Share a memory of east lake</v-btn
        >
      </div>
    </MainPage>
  </div>
</template>

<script>
import MainPage from "./main.page";

export default {
  name: "ComingSoonPage",
  components: { MainPage },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    this.setPageContext("coming-soon", () => {
      this.loaded = true;
    });
  },
};
</script>

<style scoped lang="scss">
.home-date {
  color: #4d4d4d;
  font-size: 50px;
  font-weight: bold;
  margin: 100px 0;
}
.home-title {
  color: #e8000b;
  font-weight: bold;
  font-size: 50px;
  margin-bottom: 50px;
}
.home-description {
  max-width: 700px;
  margin: auto;
  margin-bottom: 100px;
}

@media screen and (max-width: 800px) {
  .v-btn.share-btn {
    font-size: 15px !important;
    padding: 0 20px !important;
  }
  .home-date,
  .home-title {
    font-size: 30px;
    margin: 30px 0;
  }
  .social-aggragator {
    text-align: left;
    &__title {
      font-size: 24px;
      line-height: 28px;
    }
    &__intro {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
